/**
 * Auth helpers for inventory transfer APIs.
 *
 * login_employee_id:
 * - superadmin / merchant → null (do not send an employee id)
 * - employee / other staff login types → employee id when available
 */

function coerceEmployeeId(raw) {
  if (raw == null || raw === "") return null;
  const trimmed = String(raw).trim();
  if (!trimmed || trimmed.toLowerCase() === "null" || trimmed.toLowerCase() === "undefined") {
    return null;
  }
  const n = Number(trimmed);
  return Number.isFinite(n) ? n : trimmed;
}

function readLocalEmpId() {
  try {
    if (typeof window === "undefined") return null;
    return coerceEmployeeId(window.localStorage.getItem("emp_id"));
  } catch {
    return null;
  }
}

/**
 * Resolve employee id for transfer API call sites (list, create, status, sync, etc.).
 * Pass the result as `login_employee_id` on every transfer request.
 */
export function resolveLoginEmployeeId(loginRecord, loginType) {
  const type = String(loginType ?? loginRecord?.login_type ?? "")
    .trim()
    .toLowerCase();

  if (!type || type === "superadmin" || type === "merchant") {
    return null;
  }

  const fromRecord = coerceEmployeeId(
    loginRecord?.employee_id ?? loginRecord?.data?.employee_id ?? null,
  );
  if (fromRecord != null) return fromRecord;

  return readLocalEmpId();
}

/**
 * Normalize `login_employee_id` for request bodies.
 * Ensures employee (and other staff) sessions always send an id when available;
 * merchant / superadmin always get null.
 */
export function normalizeTransferLoginEmployeeId(login_employee_id, login_type) {
  const type = String(login_type ?? "")
    .trim()
    .toLowerCase();

  if (type === "superadmin" || type === "merchant") {
    return null;
  }

  const provided = coerceEmployeeId(login_employee_id);
  if (provided != null) return provided;

  // Safety net when a call site forgot to resolve, but session is staff/employee.
  if (type) {
    return readLocalEmpId();
  }

  return null;
}
